<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['name']" [helpText]="'USER.HELP_TEXT.NAME'"></astral-input>
          @if (form.controls['password']) {
            <astral-input
              type="password"
              [control]="form.controls['password']"
              [helpText]="'USER.HELP_TEXT.PASSWORD'"
            ></astral-input>
          }
        </astral-layout-group>
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['personName']" [helpText]="'USER.HELP_TEXT.NAMEOFUSER'"></astral-input>
          <astral-input type="phone" [control]="form.controls['phoneNumber']" [helpText]="'USER.HELP_TEXT.PHONENUMBER'"></astral-input>
          <astral-masked-input
            [control]="form.controls['civicNumber']"
            [mask]="civicNumberMask"
            [maskFormat]="civicNumberMaskFormat"
            [helpText]="'USER.HELP_TEXT.CIVICNUMBER'"
          ></astral-masked-input>
        </astral-layout-group>
      </section>
      <section class="astral-section-surface astral-stack-m">
        <h3 class="astral-section-heading">{{ 'USERGROUP.MEMBER_OF_GROUPS' | translate }}</h3>
        <astral-checkbox
          [checked]="showUserGroupPermissions"
          [label]="'USERGROUP.PERMISSIONS.SHOW_DETAILS'"
          variant="compact"
          (checkedChange)="toggleShowUserGroupPermissions()"
        ></astral-checkbox>
        <astral-layout-group class="access-toggle-grid" [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          @for (userGroup of userGroupsSelection; track userGroup) {
            <div class="access-toggle-block">
              <astral-toggle [control]="form.controls[userGroup.value]"></astral-toggle>
              @if (showUserGroupPermissions) {
                <div class="detailed-access-list">
                  @if (hasUserGroupFeatures(userGroup.value)) {
                    <ul>
                      @for (feature of getUserGroupFeatures(userGroup.value); track feature) {
                        <li>{{ feature | translate }}</li>
                      }
                    </ul>
                  } @else {
                    <p class="access-toggle-block__fallback">{{ 'USERGROUP.PERMISSIONS.NO_DESCRIPTION' | translate }}</p>
                  }
                </div>
              }
            </div>
          }
        </astral-layout-group>
        <div>
          <h5>{{ 'USERGROUP.PERMISSIONS.APPLIED_PERMISSIONS' | translate }}</h5>
          @if (appliedAccesses.length === 0) {
            <div>
              <i>
                {{ 'USERGROUP.PERMISSIONS.NO_PERMISSIONS' | translate }}
              </i>
            </div>
          }
          @if (appliedAccesses.length > 0) {
            <ul class="access-source-list">
              @for (access of appliedAccesses; track access) {
                <li>
                  {{ access.featureName | translate }}
                  <astral-popover [helpText]="getHelperText(access.appliedByNames)"></astral-popover>
                </li>
              }
            </ul>
          }
        </div>
      </section>
      @if (executorGroupsSelection.length > 0) {
        <section class="astral-section-surface astral-stack-m">
          <h3 class="astral-section-heading">{{ 'EXECUTORGROUP.MEMBER_OF_GROUPS' | translate }}</h3>
          <astral-layout-group class="access-toggle-grid" [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            @for (executorGroup of executorGroupsSelection; track executorGroup) {
              <div class="access-toggle-block">
                <astral-toggle [control]="form.controls[executorGroup.value]"></astral-toggle>
              </div>
            }
          </astral-layout-group>
        </section>
      }
    </form>
  }
</section>
